import { Home, Sdg1, Sdg2, Sdg5, Sdg6, Sdg10, Sdg12, Sdg14, Sdg15, MeasuringProductiveSustainableAgriculture, Annex, ConflictSnapshot } from './views/AppViewsFr'
import React, { useEffect, useState, useRef} from "react";
import {
    Route,
    useLocation,
    Routes,
    HashRouter,
} from "react-router-dom";
import "./App.css";
import NavMain from "./components/NavMain"
import NavEx from "./components/NavEx"


function AnimatedSwitch() {
    const location = useLocation();

    const [displayLocation, setDisplayLocation] = useState(location);
    const [order, setOrder] = useState(1);
    const [direction, setDirection] = useState('next');
    const [transitionStage, setTransistionStage] = useState("fadeIn");

    const usePrevious = (value) => {
        const ref = useRef();
        useEffect(() => {
            ref.current = value;
        });
        return ref.current;
    };

    const prevOrder = usePrevious(order);

    useEffect(() => {
        document.getElementById('loader').classList.remove('loading');
        if ((location !== displayLocation)) setTransistionStage("fadeOut");
        if (prevOrder > order) {
            setDirection("next")
        } else if ((prevOrder < order)) {
            setDirection("prev")
        }

    }, [location, displayLocation, order, prevOrder]);


    return (
        <div>

             <div className="modal fade" id="copyrightModal" tabIndex="-1" aria-labelledby="copyrightModalLabel" aria-hidden="true">
  <div className="modal-dialog modal-lg">
    <div className="modal-content">
      <div className="modal-header">
        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div className="modal-body">
        <p>Citer comme suit:<br/>FAO. 2022. <em>Suivi des progrès accomplis dans le cadre des indicateurs des objectifs de développement durable liés à l’alimentation et à l’agriculture en 2022.</em> Rome <a href="https://doi.org/10.4060/cc1403fr">https://doi.org/10.4060/cc1403fr</a></p>
        <p>Les appellations employées dans ce produit d’information et la présentation des données qui y figurent n’impliquent de la part de l’Organisation des Nations Unies pour l’alimentation et l’agriculture (FAO) aucune prise de position quant au statut juridique ou au stade de développement des pays, territoires, villes ou zones ou de leurs autorités, ni quant au tracé de leurs frontières ou limites. Les lignes pointillées sur les cartes représentent des frontières approximatives dont le tracé peut ne pas avoir fait l’objet d’un accord définitif. Le fait qu’une société ou qu’un produit manufacturé, breveté ou non, soit mentionné ne signifie pas que la FAO approuve ou recommande ladite société ou ledit produit de préférence à d’autres sociétés ou produits analogues qui ne sont pas cités.</p>
        <p>Les opinions exprimées dans ce produit d’information sont celles du/des auteur(s) et ne reflètent pas nécessairement les vues ou les politiques de la FAO.</p>
        <p className="mb-1">ISBN 978-92-5-136808-4 <br />© FAO, 2022</p>
        <img className="copyright-modal-img mb-4" src="http://www.fao.org/fileadmin/templates/SDG-progress-report/2021/static/media/copyright.png" alt="copyright" />
        <p>Certains droits réservés. Cette œuvre est mise à la disposition du public selon les termes de la Licence Creative Commons Attribution-Pas d’Utilisation Commerciale-Partage dans les Mêmes Conditions 3.0 Organisations Intergouvernementales (CC BY NC SA 3.0 IGO; <a href="https://creativecommons.org/licenses/by-nc-sa/3.0/igo/legalcode.fr">https://creativecommons.org/licenses/by-nc-sa/3.0/igo/legalcode.fr</a>).</p>
        <p>Selon les termes de cette licence, cette œuvre peut être copiée, diffusée et adaptée à des fins non commerciales, sous réserve que la source soit mentionnée. Lorsque l’œuvre est utilisée, rien ne doit laisser entendre que la FAO cautionne tels ou tels organisation, produit ou service. L’utilisation du logo de la FAO n’est pas autorisée. Si l’œuvre est adaptée, le produit de cette adaptation doit être diffusé sous la même licence Creative Commons ou sous une licence équivalente. Si l’œuvre est traduite, la traduction doit obligatoirement être accompagnée de la mention de la source ainsi que de la clause de non-responsabilité suivante: «La traduction n’a pas été réalisée par l’Organisation des Nations Unies pour l’alimentation et l’agriculture (FAO). La FAO n’est pas responsable du contenu ni de l’exactitude de la traduction. L’édition originale [langue] est celle qui fait foi.»</p>
        <p>Tout litige relatif à la présente licence ne pouvant être résolu à l'amiable sera réglé par voie de médiation et d'arbitrage tel que décrit à l'Article 8 de la licence, sauf indication contraire contenue dans le présent document. Les règles de médiation applicables seront celles de l'Organisation mondiale de la propriété intellectuelle (<a href="http://www.wipo.int/amc/fr/mediation/rules">http://www.wipo.int/amc/fr/mediation/rules</a>) et tout arbitrage sera mené conformément au Règlement d'arbitrage de la Commission des Nations Unies pour le droit commercial international (CNUDCI).</p>
        <p><b>Matériel attribué à des tiers.</b> Il incombe aux utilisateurs souhaitant réutiliser des informations ou autres éléments contenus dans cette œuvre qui y sont attribués à un tiers, tels que des tableaux, des figures ou des images, de déterminer si une autorisation est requise pour leur réutilisation et d’obtenir le cas échéant la permission de l’ayant-droit. Toute action qui serait engagée à la suite d’une utilisation non autorisée d’un élément de l’œuvre sur lequel une tierce partie détient des droits ne pourrait l’être qu’à l’encontre de l’utilisateur.</p>
        <p><b>Ventes, droits et licences.</b> Les produits d’information de la FAO sont disponibles sur le site web de la FAO (<a href="http://www.fao.org/publications">www.fao.org/publications</a>) et peuvent être achetés sur demande adressée par courriel à: <a href="mailto:publications-sales@fao.org">publications-sales@fao.org</a>. Les demandes visant un usage commercial doivent être soumises à: <a href="http://www.fao.org/contact-us/licence-request">www.fao.org/contact-us/licence-request</a>. Les questions relatives aux droits et aux licences doivent être adressées à: <a href="mailto:copyright@fao.org">copyright@fao.org</a>.</p>
      </div>
      <div className="modal-footer">
        <button type="button" className="btn btn-secondary" data-dismiss="modal">Fermer</button>
      </div>
    </div>
  </div>
</div>

             <NavMain logo={require('./images/fao-logo.svg').default} copyright="Copyright" scroll="Faites défiler vers le haut" />

            <div
                className={`${transitionStage} ${direction}`}
                onAnimationEnd={() => {
                    if (transitionStage === "fadeOut") {
                        setTransistionStage("fadeIn");
                        setDisplayLocation(location);
                        if (location.state != null) {
                            setOrder(location.state.order);
                        }
                    }
                    document.body.scrollTo({ top: 0, left: 0 })
                }}
            >
                <div className='main'>
                    <Routes location={displayLocation}>
                        <Route  path="/" element={<Home />} />
                        <Route path="/1" element={<Sdg1 />} />
                        <Route path="/2" element={<Sdg2 />} />
                        <Route path="/5" element={<Sdg5 />} />
                        <Route path="/6" element={<Sdg6 />} />
                        <Route path="/10" element={<Sdg10 />} />
                        <Route path="/12" element={<Sdg12 />} />
                        <Route path="/14" element={<Sdg14 />} />
                        <Route path="/15" element={<Sdg15 />} />
                        <Route path="/measuring-productive-sustainable-agriculture" element={<MeasuringProductiveSustainableAgriculture />} />
                        <Route path="/annex" element={<Annex />} />
                        <Route path="/conflict-snapshot" element={<ConflictSnapshot />} />
                        <Route path="*" element={<Home />} />
                    </Routes>
                </div>
            </div>
        </div>
    );
}

export default function App() {
    return (
        <div className="App">
            <HashRouter>
                <NavEx />
                <AnimatedSwitch />
            </HashRouter>
        </div>
    );
}